<template>
  <div>
    <v-row no-gutters wrap>
      <v-col>
        <v-carousel cycle hide-delimiters>
          <v-carousel-item v-for="(item,i) in items" :key="i" :src="item.src" reverse-transition="fade-transition" transition="fade-transition">
            <v-row align="center" justify="center">
              <div class="carouselTitle font-italic font-weight-bold headline">
                {{ item.carouselTitle }}
              </div>
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col xs12>
        <v-card color="#DCEDC8" class="px-2 py-3 mb-4 justify-center" flat>
          <v-card-text class="text-center title justify-start">Zambezi Farmer is the first truly national platform that brings together the Zambian Agricultural industry’s knowledge and connects farmers in a way never seen before.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" md="4">
        <v-card class="px-1 mb-2 mx-2 elevation-4" color="farmer_green" dark>
          <v-card-title class="layout justify-center">
            <div>
              <h3 class="display-1 mb-0 text-center">For Farmers</h3>
            </div>
          </v-card-title>
          <v-card-subtitle class="title font-italic font-weight-black">Banda is a producer himself and has his own farming dreams, passions and stresses. He has built this from the point of view of a farmer. You are put first. We appreciate feedback as we are serious about getting this right for you. We don’t spam farmers, rather we introduce you to businesses that are aligned with your location and interests.
          </v-card-subtitle>
          <div class="layout justify-center">
            <v-btn class="ma-2" title large color="#AFB42BFF" dark depressed>
              <h2>VISION</h2>
            </v-btn>
          </div>
          <v-img src="../assets/about/vision.jpg" aspect-ratio="1.94">
          </v-img>
          <v-card-text class="subtitle-1">
            <div>To be the online home of a connected, sustainable and profitable Zambian agricultural industry.
              <br><br><br>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="mb-2 mx-2 elevation-4" color="farmer_green" dark>
          <v-card-title class="layout justify-center">
            <div>
              <h3 class="display-1 mb-0 text-center">For Agribusiness</h3>
            </div>
          </v-card-title>
          <v-card-subtitle class="title font-italic font-weight-black">We have formulated agribusiness memberships based on speaking to organisations across the country and understanding their needs and frustrations. Our membership model is new, innovative and aimed at giving agribusinesses value for money.<br><br><br></v-card-subtitle>
          <div class="layout justify-center">
            <v-btn class="ma-2" title large color="#AFB42BFF" dark depressed>
              <h2>MISSION</h2>
            </v-btn>
          </div>
          <v-img src="../assets/about/mission.jpg" aspect-ratio="1.94">
          </v-img>
          <v-card-text class="subtitle-1">
            <div>By creating a trusted and independent industry-wide ecosystem that brings knowledge, people and business together, our mission is to drive innovation and growth for all involved in Zambian agriculture.</div>
            <br>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="mb-2 mx-2 elevation-4" color="farmer_green" dark>
          <v-card-title class="layout justify-center">
            <div>
              <h3 class="display-1 mb-0 text-center">For Agriculture </h3>
            </div>
          </v-card-title>
          <v-card-subtitle class="title font-italic font-weight-black">We provide a platform that for the first time gets serious about whole of industry collaboration and knowledge exchange. By creating a trusted industry-wide ecosystem that brings knowledge, people and business across Zambian agriculture together, our mission is to drive innovation and growth for all involved.
            <br>
          </v-card-subtitle>
          <div class="layout justify-center">
            <v-btn class="ma-2" title large color="#AFB42BFF" dark depressed>
              <h2>PURPOSE</h2>
            </v-btn>
          </div>
          <v-img src="../assets/about/purpose.jpg" aspect-ratio="1.94">
          </v-img>
          <v-card-text class="subtitle-1">
            <div>To make the online experience for farmers more accessible, efficient and rewarding.<br><br><br>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-layout align-center justify-center>
      <v-btn class="farmer_green white--text mt-1 headline" block text tile dark large>Reach Us</v-btn>
    </v-layout>

    <section>
      <v-container grid-list-xl>
        <v-layout row wrap justify-center class="mx-2">
          <v-flex xs12 sm6 md6 v-for="(item, index) in contacts" :key="index">
            <v-card class="elevation-0 transparent">
              <v-list class="transparent">
                <v-list-item class="farmer_green white--text">
                  <v-list-item-action>
                    <v-icon color="white">{{item.location.icon}}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="contact white--text">{{item.location.title}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="subheading">
                  <v-list-item-action>
                    <a class="link" :href="item.phone.link"><v-icon color="farmer_green">{{item.phone.icon}}</v-icon></a>
                  </v-list-item-action>
                  <v-list-item-content class="phone">
                    <v-list-item-title class="contact farmer_green--text"><a class="link" :href="item.phone.link">{{item.phone.title}}</a></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <a class="link" :href="item.email.link"><v-icon color="farmer_green">{{item.email.icon}}</v-icon></a>
                  </v-list-item-action>
                  <v-list-item-content class="email">
                    <v-list-item-title class="contact"><a class="link" :href="item.email.link" target="_top">
                        {{item.email.title}}
                      </a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: require('../assets/about/zambezi-river.jpg'),
          carouselTitle: 'Beatiful Zambezi'
        },
        {
          src: require('../assets/about/cowshed-cattle.jpg'),
          carouselTitle: 'Cattle Farming'
        },
        {
          src: require('../assets/about/victoria-Falls.jpg'),
          carouselTitle: 'Victoria Falls'
        },
        {
          src: require('../assets/about/rwanda-farmer.jpg'),
          carouselTitle: 'Farmer Landscaping'
        }
      ]
    }
  },
  computed: {
    contacts() {
      return [
        {
          location: {
            icon: 'place',
            title: 'Lusaka, Zambia'
          },
          phone: {
            icon: 'phone',
            title: '+260 9 70 83 88 48',
            link: 'tel:+260970838848'
          },
          email: {
            icon: 'email',
            title: 'info@zambezifarmer.com',
            link: 'mailto:info@zambezifarmer.com'
          }
        },
        {
          location: {
            icon: 'place',
            title: 'Ndola, Zambia'
          },
          phone: {
            icon: 'phone',
            title: '+260 9 63 71 12 78',
            link: 'tel:+260963711278'
          },
          email: {
            icon: 'email',
            title: 'info@zambezifarmer.com',
            link: 'mailto:info@zambezifarmer.com'
          }
        }
      ]
    }
  }
}
</script>

<style scoped>
.carouselTitle {
  color: white;
  padding: 0 10px 0 10px;
  text-align: center;
  /* border-radius: 5px; */
  position: absolute;
  bottom: 0px;
  width: 250px;
  background-color: rgba(0, 0, 0, 0.5);
}
.phone:hover,
.email:hover {
  overflow: visible;
}
.service {
  font-size: 20px;
}
.motto {
  font-size: 20px;
}
.contact {
  font-size: 20px;
}
.parax {
  margin-top: -50px;
}
.link {
  text-decoration: none;
}
</style>
